import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { memo } from 'react';
import { ProductCellPrimary, } from './ProductCellPrimary';
import { ProductCellQuaternary, } from './ProductCellQuaternary';
import { ProductCellSecondary, } from './ProductCellSecondary';
import { ProductCellTertiary, } from './ProductCellTertiary';
const types = {
    primary: 'primary',
    quaternary: 'quaternary',
    secondary: 'secondary',
    tertiary: 'tertiary',
};
const ProductCell = (props) => {
    if (props.type === types.primary) {
        return (_jsx(ProductCellPrimary, Object.assign({}, props)));
    }
    if (props.type === types.secondary) {
        return (_jsx(ProductCellSecondary, Object.assign({}, props)));
    }
    if (props.type === types.tertiary) {
        return (_jsx(ProductCellTertiary, Object.assign({}, props)));
    }
    if (props.type === types.quaternary) {
        return (_jsx(ProductCellQuaternary, Object.assign({}, props)));
    }
    return null;
};
const MemoizedProductCell = memo(ProductCell);
export { MemoizedProductCell as ProductCell };
// MC-1068 Temporary hack for Storybook.
export default ProductCell;
